<template>
  <SessionSlide
    ref="slide"
    :id="'slide' + props.index"
    visual-position="fixed"
    :class="{
      'slide-after-activity': !isDisplayed,
      'submitted-mapping': isDisplayed,
    }"
    :data-test="`session-slide-${index}`"
  >
    <template #text>
      <SlideText :text="prismicSlice.primary.text_body" />
    </template>
    <template #visual>
      <TeamEffectivenessQuestionnaire
        v-if="controlType === 'cms-team-effectiveness-review'"
        :is-submitting="isSubmitting"
        @submit="submitQuestionnaire"
        class="team-effectiveness-questionnaire-in-session"
      />
    </template>
  </SessionSlide>
</template>

<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import SessionSlide from "../../sessions/session-slide.vue";
import { CmsControlSlide } from "../../../services/cms/cms-type-definitions";
import TeamEffectivenessQuestionnaire from "../../team-effectiveness/team-effectiveness-questionnaire.vue";
import {
  TeamEffectivenessQuestionnaireCreationApiModel,
  TeamEffectivenessRatingsApiModel,
} from "../../../api-models";
import { PrismicSliceWithData } from "../../../views/cms/cms-session.vue";
import { useCmsSessionStore } from "../../../stores/useCmsSessionStore";
import pinia from "../../../stores";
import SlideText from "./slide-text.vue";
import { useToggle } from "../../../composables/useToggle";

const props = defineProps<{ slice: PrismicSliceWithData; index: number }>();

const cmsSessionStore = useCmsSessionStore(pinia());

const { state: isDisplayed, toggleState: toggleIsDisplayed } = useToggle(false);

// const visual = ref<CmsImg | null>(null);
const slide = ref<SessionSlide | null>(null);
const isSubmitting = ref(false);

const prismicSlice = computed<CmsControlSlide>(() => {
  return props.slice.prismicSlice as CmsControlSlide;
});

const controlType = computed(() => prismicSlice.value.primary.control.type);
const visualDiv = computed(() => slide?.value?.visualDiv);

// TODO: to handle properly => get reviewId
const submitQuestionnaire = (rawRatings: TeamEffectivenessRatingsApiModel): void => {
  isSubmitting.value = true;
  // get reviewId
  const request = {
    reviewId: "",
    rawRatings,
  } as TeamEffectivenessQuestionnaireCreationApiModel;
  // POST questionnaire => isSubmitting = false;
};

watchEffect(() => {
  if (!isDisplayed.value && cmsSessionStore.sectionsToDisplay.includes(props.slice.section)) {
    toggleIsDisplayed();
  }
});

defineExpose({
  slide,
  visualDiv,
});
</script>
